import { fg } from '@atlaskit/platform-feature-flags';

import { isSiteScopedKnowledgeSource } from './is-site-scoped-knowledge-source.ts';

type KnowledgeSourceWithSite = {
	cloudId?: string | null;
	source: string;
};

type MultiSiteKnowledgeExperienceOptions = {
	availableSources: ReadonlyArray<KnowledgeSourceWithSite | null | undefined>;
	currentCloudId?: string;
	storedSources: ReadonlyArray<KnowledgeSourceWithSite | null | undefined>;
};

export const shouldShowMultiSiteKnowledgeExperience = ({
	availableSources,
	currentCloudId,
	storedSources,
}: MultiSiteKnowledgeExperienceOptions): boolean => {
	if (!fg('rovo_agents_unit_scoped') || !currentCloudId) {
		return false;
	}

	return [...availableSources, ...storedSources].some(
		(source) =>
			source !== null &&
			source !== undefined &&
			isSiteScopedKnowledgeSource(source.source) &&
			source.cloudId !== null &&
			source.cloudId !== undefined &&
			source.cloudId !== currentCloudId,
	);
};
